(() => {
  const FinksAppointment = {
    currentWeekStart: new Date(),
    selectedDate: null,
    selectedTime: null,
    outlookCalendarData: [],
    isLoadingSlots: false,
    lastSelectedDateString: null,
    selectedHourSlot: "",
    
    config: {
      calendarApiEndpoint: "",
      bookApiEndpoint: "",
      calendarApiToken: "",
      modifyPageUrl: ""
    },

    init(config) {
      this.config = { ...this.config, ...config };
      this.currentWeekStart.setDate(
        this.currentWeekStart.getDate() - this.currentWeekStart.getDay()
      );
      
      this.setupEventListeners();
      this.initializePreselections();
    },

    setupEventListeners() {

      let usingKeyboard = false;
      
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Tab') {
          usingKeyboard = true;
        }
      });
      
      document.addEventListener('mousedown', () => {
        usingKeyboard = false;
      });
      
      const handleFocus = (e) => {
        if (usingKeyboard) {
          e.target.classList.add('keyboard-focus');
        }
      };
      
      const handleBlur = (e) => {
        e.target.classList.remove('keyboard-focus');
      };
      
      const appointmentSection = document.getElementById('finks-2026-appointment-section');
      if (appointmentSection) {
        const formElements = appointmentSection.querySelectorAll('input, textarea, select, button');
        formElements.forEach(element => {
          element.addEventListener('focus', handleFocus);
          element.addEventListener('blur', handleBlur);
        });
      }

      document.querySelectorAll('input[name="apptPurpose"]').forEach(input => {
        input.addEventListener('change', (e) => this.handlePurposeChange(e));
      });


      document.querySelectorAll('input[name="apptLocation"]').forEach(input => {
        input.addEventListener('change', (e) => this.handleLocationChange(e));
      });

      // Tab navigation
      document.querySelectorAll('[data-toggle="tab"]').forEach(btn => {
        btn.addEventListener('click', (e) => this.handleTabClick(e));
      });

      // Back buttons
      document.querySelectorAll('.finks-2026-backbtn').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const target = btn.getAttribute('data-target');
          if (target) {
            this.showTab(target);
          }
        });
      });

      // Radio button styling
      document.querySelectorAll('input[type="radio"]').forEach(radio => {
        radio.addEventListener('change', (e) => this.handleRadioChange(e));
      });

      // Floating labels
      document.querySelectorAll('.finks-2026-floating input, .finks-2026-floating textarea').forEach(input => {
        ['focus', 'blur', 'input'].forEach(event => {
          input.addEventListener(event, (e) => this.handleFloatingLabel(e));
        });
        
        if (input.value !== "") {
          this.handleFloatingLabel({ target: input, type: 'input' });
        }
      });

      const emailInput = document.getElementById('finks-2026-fldEmail');
      const emailError = document.getElementById('finks-2026-email-error');
      
      if (emailInput && emailError) {
        emailInput.addEventListener('input', () => {
          if (emailInput.value.includes('+')) {
            emailError.style.display = 'block';
            emailInput.setCustomValidity('Email addresses with "+" sign are not allowed');
          } else {
            emailError.style.display = 'none';
            emailInput.setCustomValidity('');
          }
        });
        
        emailInput.addEventListener('invalid', (e) => {
          if (emailInput.value.includes('+')) {
            e.preventDefault();
            emailError.style.display = 'block';
          }
        });
      }
      

      const form = document.getElementById('finks-2026-appointmentForm');
      if (form) {

        form.setAttribute('action', 'javascript:void(0);');
        form.setAttribute('onsubmit', 'return false;');
        
        form.addEventListener('submit', async (e) => {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          if (emailInput && emailInput.value.includes('+')) {
            emailError.style.display = 'block';
            emailInput.focus();
            return false;
          }
          
          const result = await this.saveApptDetail();
          return false;
        }, { capture: true });
      }

 
      const proceedBtn = document.getElementById('finks-2026-proceedToForm');
      if (proceedBtn) {
        proceedBtn.addEventListener('click', () => {
          this.showTab('#finks-2026-appointment-customer-info');
        });
      }
    },

    initializePreselections() {
      const checkedLocation = document.querySelector('input[name="apptLocation"]:checked');
      if (checkedLocation) {
        checkedLocation.closest('.finks-2026-store-label')?.classList.add('selected');
        checkedLocation.parentElement.querySelector('.finks-2026-store-card')?.classList.add('active');
      }
      
      this.handleLocationUrlParameter();
      

      this.updateStoreAddressSelect();
      this.updateTimezoneLabel();
    },

    getTimezoneForLocation() {
      const location = this.getLocationValue();
        return location === 'franklin' ? 'America/Chicago' : 'America/New_York';
      },

    getTimezoneLabelForLocation() {
      const location = this.getLocationValue();
          return location === 'franklin' ? 'CST' : 'EST';
    },

    getLocationValue() {
      const selectedLocationRadio = document.querySelector('input[name="apptLocation"]:checked');
      if (!selectedLocationRadio) {
        return null;
      }
      
      const storeName = selectedLocationRadio
        .closest('label')
        ?.querySelector('.finks-2026-heading-30')
        ?.textContent
        ?.trim() || '';
      
      if (!storeName) {
        return null;
      }
      
      const storeNameLower = storeName.toLowerCase();
      // Fink's location handles must match backend: 419, birkdale, chattanooga, franklin, gaytonandbroad, hilltop, northhills, southpark
      if (storeNameLower.includes('419') || (storeNameLower.includes('colonial') && !storeNameLower.includes('hilltop'))) {
        return '419';
      } else if (storeNameLower.includes('birkdale')) {
        return 'birkdale';
      } else if (storeNameLower.includes('chattanooga')) {
        return 'chattanooga';
      } else if (storeNameLower.includes('hilltop')) {
        return 'hilltop';
      } else if (storeNameLower.includes('north hills') || storeNameLower.includes('northhills')) {
        return 'northhills';
      } else if (storeNameLower.includes('gayton') || storeNameLower.includes('broad')) {
        return 'gaytonandbroad';
      } else if (storeNameLower.includes('southpark') || storeNameLower.includes('south park')) {
        return 'southpark';
      } else if (storeNameLower.includes('franklin')) {
        return 'franklin';
      }
      return null;
    },

    handleLocationUrlParameter() {
      const urlParams = new URLSearchParams(window.location.search);
      const locationParam = urlParams.get('location');
      
      if (!locationParam) {
        return;
      }
      
      const locationRadios = document.querySelectorAll('input[name="apptLocation"]');
      locationRadios.forEach(radio => {
        const storeName = radio
          .closest('label')
          ?.querySelector('.finks-2026-heading-30')
          ?.textContent
          ?.trim()
          ?.toLowerCase() || '';
        
        const locationValue = this.getLocationValueFromStoreName(storeName);
        
        if (locationValue && locationValue.toLowerCase() === locationParam.toLowerCase()) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change'));
        }
      });
    },

    getLocationValueFromStoreName(storeName) {
      if (!storeName) {
        return null;
      }
      const storeNameLower = storeName.toLowerCase();
      if (storeNameLower.includes('419') || (storeNameLower.includes('colonial') && !storeNameLower.includes('hilltop'))) {
        return '419';
      } else if (storeNameLower.includes('birkdale')) {
        return 'birkdale';
      } else if (storeNameLower.includes('chattanooga')) {
        return 'chattanooga';
      } else if (storeNameLower.includes('hilltop')) {
        return 'hilltop';
      } else if (storeNameLower.includes('north hills') || storeNameLower.includes('northhills')) {
        return 'northhills';
      } else if (storeNameLower.includes('gayton') || storeNameLower.includes('broad')) {
        return 'gaytonandbroad';
      } else if (storeNameLower.includes('southpark') || storeNameLower.includes('south park')) {
        return 'southpark';
      } else if (storeNameLower.includes('franklin')) {
        return 'franklin';
      }
      return null;
    },

    handlePurposeChange(e) {
      const selectedValue = e.target.value;
      const dataAttr = e.target.getAttribute('data-attr');

      document.querySelectorAll('.finks-2026-rolexConsentClass').forEach(el => {
        el.classList.remove('show');
      });
      
      const defaultText = document.getElementById('finks-2026-defaultConsentText');
      if (defaultText) defaultText.style.display = 'block';

      if (dataAttr === 'RW') {
        const watchConsent = document.querySelector('.finks-2026-rolexWatchConsent');
        if (watchConsent) watchConsent.classList.add('show');
        if (defaultText) defaultText.style.display = 'none';
      } else if (dataAttr === 'RS') {
        const serviceConsent = document.querySelector('.finks-2026-rolexServiceConsent');
        if (serviceConsent) serviceConsent.classList.add('show');
        if (defaultText) defaultText.style.display = 'none';
      }

      this.updateAppointmentTrackingInfo();

      setTimeout(() => {
        document.querySelector('.finks-2026-tab-pane.active')?.classList.remove('active', 'show');
        document.getElementById('finks-2026-please-note')?.classList.add('active', 'show');
        if (typeof window.recalcOpenAccordion === 'function') {
          window.recalcOpenAccordion();
        }
      }, 300);
    },

    updateTimezoneLabel() {
      const noteEl = document.getElementById('finks-2026-timeslot-note');
      if (!noteEl) return;
      const tzLabel = this.getTimezoneLabelForLocation();
      noteEl.textContent = `All appointment times are in ${tzLabel}`;
    },

    handleLocationChange(e) {
      const name = e.target.name;
      
      document.querySelectorAll(`input[name="${name}"]`).forEach(input => {
        input.closest('label')?.classList.remove('selected');
        input.closest('.finks-2026-homeContactBlock')?.classList.remove('selected');
        input.closest('.finks-2026-store-label')?.classList.remove('selected');
      });

      e.target.closest('label')?.classList.add('selected');
      e.target.closest('.finks-2026-homeContactBlock')?.classList.add('selected');
      e.target.closest('.finks-2026-store-label')?.classList.add('selected');
      
      if (name === 'apptLocation') {
        document.querySelectorAll('.finks-2026-store-card').forEach(card => {
          card.classList.remove('active');
        });
        
        const storeCard = e.target.parentElement.querySelector('.finks-2026-store-card');
        if (storeCard) storeCard.classList.add('active');
        
        this.updateSelectedLocation();
        this.updateStoreAddressSelect();
        this.updateTimezoneLabel();
        
        // Refresh availability if date/time tab is already shown
        const dateTimeTab = document.getElementById('finks-2026-appointment-date-of-time');
        if (dateTimeTab && dateTimeTab.classList.contains('active')) {
          // If a date is already selected, refresh the time slots
          if (this.selectedDate) {
            this.renderTimeSlots();
          }
        }
      }
    },

    handleRadioChange(e) {
      const name = e.target.name;
      
      document.querySelectorAll(`input[name="${name}"]`).forEach(input => {
        input.closest('label')?.classList.remove('selected');
        input.closest('.finks-2026-homeContactBlock')?.classList.remove('selected');
        input.closest('.finks-2026-store-label')?.classList.remove('selected');
      });

      e.target.closest('label')?.classList.add('selected');
      e.target.closest('.finks-2026-homeContactBlock')?.classList.add('selected');
      e.target.closest('.finks-2026-store-label')?.classList.add('selected');
    },

    handleTabClick(e) {
      e.preventDefault();
      const target = e.currentTarget.getAttribute('data-target');
      this.showTab(target);
    },

    // showTab(targetSelector) {
    //   document.querySelector('.finks-2026-tab-pane.active')?.classList.remove('active', 'show');
      
    //   setTimeout(() => {
    //     const targetTab = document.querySelector(targetSelector);
    //     if (targetTab) {
    //       targetTab.classList.add('active', 'show');
          
    //       if (targetSelector === '#finks-2026-appointment-date-of-time') {
    //         setTimeout(() => this.initializeDateTimePicker(), 200);
    //       }
    //     }
    //   }, 150);

    //   this.updateDisplayedInfo();
    // },

    showTab(targetSelector) {
      document.querySelector('.finks-2026-tab-pane.active')?.classList.remove('active', 'show');
      
      setTimeout(() => {
        const targetTab = document.querySelector(targetSelector);
        if (targetTab) {
          targetTab.classList.add('active', 'show');
          
          if (typeof window.recalcOpenAccordion === 'function') {
            window.recalcOpenAccordion();
          }
          
          if (targetSelector === '#finks-2026-appointment-date-of-time') {
            setTimeout(() => {
              this.initializeDateTimePicker();
              if (typeof window.recalcOpenAccordion === 'function') {
                window.recalcOpenAccordion();
              }
            }, 200);
          }
        }
      }, 150);

      this.updateDisplayedInfo();
    },

    updateDisplayedInfo() {
      const selectedPurpose = document.querySelector('input[name="apptPurpose"]:checked')?.value;
      if (selectedPurpose) {
        const purposeText = document.getElementById('finks-2026-apptPurposeText');
        if (purposeText) purposeText.textContent = selectedPurpose;
      }

      const selectedLocation = document.querySelector('input[name="apptLocation"]:checked')?.value;
      const selectedLocationName = document.querySelector('input[name="apptLocation"]:checked')
        ?.closest('label')?.querySelector('.finks-2026-heading-30')?.textContent;
      
      if (selectedLocationName) {
        const locationNameText = document.getElementById('finks-2026-apptLocationNameText');
        if (locationNameText) locationNameText.textContent = selectedLocationName;
      }
      
      if (selectedLocation) {
        const addressText = document.getElementById('finks-2026-apptAddressText');
        if (addressText) addressText.textContent = selectedLocation;
      }
    },

    handleFloatingLabel(e) {
      const input = e.target;
      const label = input.parentElement.querySelector('label');
      
      if (!label) return;

      if (input.value !== "" || e.type === 'focus') {
        label.style.top = '-15px';
        label.style.opacity = '1';
        label.style.color = '#127749';
      } else {
        label.style.top = '14px';
        label.style.opacity = '0.5';
        label.style.color = '#452C1E';
      }
    },

    async initializeDateTimePicker() {
      await this.renderWeekView();
      this.setupCalendarEventListeners();
      this.renderTimeSlots();
    },

    async checkDayAvailability(date) {
      try {
        const result = await this.checkOutlookAvailability(date);
        const { availabilityData } = result;

        if (!availabilityData || availabilityData.length === 0) {
          return true;
        }

        return availabilityData.some(slot => slot.available);
      } catch (error) {
        return true;
      }
    },

    async renderWeekView() {
      const weekContainer = document.getElementById('finks-2026-calendarGrid');
      const weekRange = document.getElementById('finks-2026-weekRange');

      if (!weekContainer || !weekRange) return;

      weekContainer.innerHTML = '';

      const weekEnd = new Date(this.currentWeekStart);
      weekEnd.setDate(weekEnd.getDate() + 6);

      const startDay = this.currentWeekStart.getDate();
      const endDay = weekEnd.getDate();
      const startMonth = this.currentWeekStart.toLocaleDateString('en-US', { month: 'long' });
      const endMonth = weekEnd.toLocaleDateString('en-US', { month: 'long' });
      const year = this.currentWeekStart.getFullYear();

      if (startMonth === endMonth) {
        weekRange.textContent = `${startDay} - ${endDay} ${startMonth}, ${year}`;
      } else {
        weekRange.textContent = `${startDay} ${startMonth} - ${endDay} ${endMonth}, ${year}`;
      }

      const today = new Date();
      today.setHours(0, 0, 0, 0);
      
      const maxDate = new Date(today);
      maxDate.setDate(maxDate.getDate() + 90);

      for (let i = 0; i < 7; i++) {
        const currentDay = new Date(this.currentWeekStart);
        currentDay.setDate(this.currentWeekStart.getDate() + i);
        currentDay.setHours(0, 0, 0, 0);

        const dayItem = document.createElement('div');
        dayItem.className = 'finks-2026-day-item';

        const dayNumber = document.createElement('div');
        dayNumber.className = 'finks-2026-day-number';
        dayNumber.textContent = currentDay.getDate().toString().padStart(2, '0');

        const dayName = document.createElement('div');
        dayName.className = 'finks-2026-day-name';
        dayName.textContent = currentDay.toLocaleDateString('en-US', { weekday: 'short' });

        dayItem.appendChild(dayNumber);
        dayItem.appendChild(dayName);

        if (currentDay.getTime() <= today.getTime() || currentDay.getTime() > maxDate.getTime()) {
          dayItem.classList.add('disabled');
        } else {
          dayItem.addEventListener('click', () => this.selectDate(currentDay));
          dayItem.dataset.date = currentDay.toISOString().split('T')[0];
        }

        weekContainer.appendChild(dayItem);
      }

      const prevBtn = document.getElementById('finks-2026-prevWeek');
      const nextBtn = document.getElementById('finks-2026-nextWeek');

      const thisWeekStart = new Date();
      thisWeekStart.setDate(thisWeekStart.getDate() - thisWeekStart.getDay());
      thisWeekStart.setHours(0, 0, 0, 0);

      const nextWeekStart = new Date(this.currentWeekStart);
      nextWeekStart.setDate(nextWeekStart.getDate() + 7);

      if (prevBtn) {
        prevBtn.disabled = this.currentWeekStart.getTime() <= thisWeekStart.getTime();
      }
      
      if (nextBtn) {
        nextBtn.disabled = nextWeekStart > maxDate;
      }
    },

    setupCalendarEventListeners() {
      const prevBtn = document.getElementById('finks-2026-prevWeek');
      const nextBtn = document.getElementById('finks-2026-nextWeek');

      if (prevBtn) {
        prevBtn.replaceWith(prevBtn.cloneNode(true));
        document.getElementById('finks-2026-prevWeek').addEventListener('click', async (e) => {
          e.preventDefault();
          this.currentWeekStart.setDate(this.currentWeekStart.getDate() - 7);
          await this.renderWeekView();
          
          this.selectedDate = null;
          this.selectedTime = null;
          this.lastSelectedDateString = null;
          
          const proceedBtn = document.getElementById('finks-2026-proceedToForm');
          if (proceedBtn) proceedBtn.disabled = true;
          
          const timeSlotsGrid = document.getElementById('finks-2026-timeSlotsGrid');
          if (timeSlotsGrid) timeSlotsGrid.innerHTML = '';
        });
      }

      if (nextBtn) {
        nextBtn.replaceWith(nextBtn.cloneNode(true));
        document.getElementById('finks-2026-nextWeek').addEventListener('click', async (e) => {
          e.preventDefault();
          this.currentWeekStart.setDate(this.currentWeekStart.getDate() + 7);
          await this.renderWeekView();
          
          this.selectedDate = null;
          this.selectedTime = null;
          this.lastSelectedDateString = null;
          
          const proceedBtn = document.getElementById('finks-2026-proceedToForm');
          if (proceedBtn) proceedBtn.disabled = true;
          
          const timeSlotsGrid = document.getElementById('finks-2026-timeSlotsGrid');
          if (timeSlotsGrid) timeSlotsGrid.innerHTML = '';
        });
      }
    },

    selectDate(date) {
      const dateString = date.toISOString().split('T')[0];
      
      if (this.lastSelectedDateString === dateString) {
        return;
      }
      
      this.selectedDate = date;
      this.selectedTime = null;
      this.lastSelectedDateString = dateString;

      document.querySelectorAll('.finks-2026-day-item').forEach(item => {
        item.classList.remove('selected');
      });

      const selectedItem = document.querySelector(`[data-date="${dateString}"]`);
      if (selectedItem) {
        selectedItem.classList.add('selected');
      }

      const proceedBtn = document.getElementById('finks-2026-proceedToForm');
      if (proceedBtn) proceedBtn.disabled = true;

      this.updateAppointmentTrackingInfo();
      this.renderTimeSlots();
    },

    renderTimeSlots() {
      const timeSlotsGrid = document.getElementById('finks-2026-timeSlotsGrid');
      const timeSlotsLoading = document.getElementById('finks-2026-timeSlotsLoading');
      
      if (!this.selectedDate || !timeSlotsGrid || !timeSlotsLoading) {
        return;
      }
      
      if (this.isLoadingSlots) {
        return;
      }
      
      this.isLoadingSlots = true;
      
      timeSlotsLoading.style.display = 'block';
      timeSlotsGrid.innerHTML = '';
      
      this.checkOutlookAvailability(this.selectedDate)
        .then(result => {
          if (!this.selectedDate || this.selectedDate.toISOString().split('T')[0] !== this.lastSelectedDateString) {
            return;
          }
          
          const { availabilityData, workingHours } = result;
          
          let availableSlots = [];
          
          if (availabilityData && availabilityData.length > 0) {
            availableSlots = availabilityData
              .filter(slot => slot.available)
              .map(slot => {
                const slotTime = new Date(slot.time);
                const tz = this.getTimezoneForLocation();
                const localTime = slotTime.toLocaleString('en-US', {
                  hour: '2-digit',
                  minute: '2-digit',
                  hour12: false,
                  timeZone: tz
                });
                const localHour = parseInt(localTime.split(':')[0]);
                const minutes = localTime.split(':')[1];
                
                const displayHour = localHour === 0 ? 12 : localHour > 12 ? localHour - 12 : localHour;
                const period = localHour >= 12 ? "PM" : "AM";
                const display = `${displayHour}:${minutes} ${period}`;

                return {
                  value: localTime,
                  display: display,
                  available: true,
                  localHour: localHour,
                  utcTime: slotTime.toISOString(),
                  type: slot.type || 'available'
                };
              })
              .filter(slot => {
                if (workingHours && workingHours.open && workingHours.close) {
                  const slotTime = new Date(slot.utcTime);
                  const openTime = new Date(workingHours.open);
                  const closeTime = new Date(workingHours.close);
                  return slotTime >= openTime && slotTime < closeTime;
                }
                return true;
              })
              .filter(slot => {
                const slotTime = new Date(slot.utcTime);
                const now = new Date();
                return slotTime > now;
              })
              .sort((a, b) => new Date(a.utcTime) - new Date(b.utcTime));
          }
          
          availableSlots.forEach(slot => {
            const timeSlot = document.createElement('button');
            timeSlot.type = 'button';
            timeSlot.className = 'finks-2026-time-slot';
            timeSlot.dataset.time = slot.value;
            timeSlot.textContent = slot.display;
            timeSlot.addEventListener('click', () =>
              this.selectTimeSlot(slot.value, slot.display, slot.utcTime)
            );
            timeSlotsGrid.appendChild(timeSlot);
          });
          
          timeSlotsLoading.style.display = 'none';
          
          if (availableSlots.length === 0) {
            timeSlotsGrid.innerHTML =
              '<div class="text-center finks-2026-body-20-light finks-2026-brownColor finks-2026-time-slots-placeholder">No available time slots for this date.</div>';
          }
          
          if (typeof window.recalcOpenAccordion === 'function') {
            window.recalcOpenAccordion();
          }
        })
        .catch(error => {
          console.error('Time slots error:', error);
          timeSlotsGrid.innerHTML =
            '<div class="text-center finks-2026-body-20-light finks-2026-brownColor finks-2026-time-slots-placeholder">Error loading time slots. Please try again.</div>';
          
          timeSlotsLoading.style.display = 'none';
        })
        .finally(() => {
          timeSlotsLoading.style.display = 'none';
          this.isLoadingSlots = false;
        });
    },

    selectTimeSlot(time, displayTime, utcTime) {
      this.selectedHourSlot = displayTime;
      this.selectedTime = time;

      document.querySelectorAll('.finks-2026-time-slot').forEach(slot => {
        slot.classList.remove('selected');
      });

      const selectedSlot = document.querySelector(`.finks-2026-time-slot[data-time="${time}"]`);
      if (selectedSlot) {
        selectedSlot.classList.add('selected');
      }

      const proceedBtn = document.getElementById('finks-2026-proceedToForm');
      if (proceedBtn) proceedBtn.disabled = false;

      const selectedDateTimeInput = document.getElementById('finks-2026-selectedDateTime');
      if (selectedDateTimeInput) {
        if (utcTime) {
          selectedDateTimeInput.value = utcTime;
        } else {
          const dateTimeString = `${this.selectedDate.toISOString().split('T')[0]} ${time}`;
          selectedDateTimeInput.value = dateTimeString;
        }
      }
      
      this.updateAppointmentTrackingInfo();
    },

    async checkOutlookAvailability(date) {
      try {
        const startDateTime = new Date(date);
        startDateTime.setUTCHours(0, 0, 0, 0);

        const endDateTime = new Date(date);
        endDateTime.setUTCHours(23, 59, 59, 999);

        const location = this.getLocationValue();

        const payload = {
          startDateTime: startDateTime.toISOString(),
          endDateTime: endDateTime.toISOString(),
        };
        
        if (location) {
          payload.location = location.toLowerCase();
        }

        const response = await fetch(this.config.calendarApiEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.config.calendarApiToken}`,
          },
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          throw new Error('Failed to fetch availability');
        }

        const result = await response.json();

        if (result.success && result.data) {
          return {
            availabilityData: result.data,
            workingHours: result.workingHours,
          };
        }

        return {
          availabilityData: [],
          workingHours: null,
        };
      } catch (error) {
        console.error('Availability check error:', error);
        return {
          availabilityData: [],
          workingHours: null,
        };
      }
    },

    async saveApptDetail() {
      let valid = true;
      
      document.querySelectorAll('.finks-2026-requiredField').forEach(field => {
        const box = field.closest('.finks-2026-fieldBox');
        if (!field.value.trim()) {
          valid = false;
          if (box) box.style.borderBottomColor = '#dc3545';
        } else {
          if (box) box.style.borderBottomColor = 'rgba(69,44,30,0.4)';
        }
      });

      const policyCheck = document.getElementById('finks-2026-fldCheckPolicy');
      if (policyCheck && !policyCheck.checked) {
        alert('Please accept the terms and conditions.');
        return false;
      }

      const commCheck = document.getElementById('finks-2026-fldCheckCommunication');
      if (commCheck && !commCheck.checked) {
        alert('Please accept communication terms.');
        return false;
      }

      if (!valid) {
        return false;
      }

      // Update appointment details before building payload
      this.updateAppointmentDetails();
      
      const appointmentInfoInput = document.getElementById('finks-2026-appointmentInformation');
      const details = JSON.parse(appointmentInfoInput?.value || '{}');

      const location = this.getLocationValue();

      const payload = {
        ...details,
        title: document.getElementById('finks-2026-fldSex')?.value,
        first_name: document.getElementById('finks-2026-fldFirstName')?.value,
        last_name: document.getElementById('finks-2026-fldLastName')?.value,
        email: document.getElementById('finks-2026-fldEmail')?.value,
        phone_code: document.getElementById('finks-2026-fldStdCode')?.value,
        phone: document.getElementById('finks-2026-fldPhone')?.value,
        country: document.getElementById('finks-2026-fldCountryResidense')?.value,
        city: document.getElementById('finks-2026-fldStoreCity')?.value,
        store_address: document.getElementById('finks-2026-fldStoreAddress')?.value,
        communication_method: document.querySelector('input[name="communication_method"]:checked')?.value,
        comments: document.getElementById('finks-2026-apptComment')?.value
      };
      
      if (location) {
        payload.location = location.toLowerCase();
      }

      try {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 30000);

        let res;
        try {
          res = await fetch(this.config.bookApiEndpoint, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${this.config.calendarApiToken}`
            },
            body: JSON.stringify(payload),
            signal: controller.signal
          });
        } catch (fetchError) {
          clearTimeout(timeoutId);
          this.updateThankYouPage();
          
          if (typeof _satellite !== 'undefined') {
            try {
              _satellite.track('bookAppointment');
            } catch (e) {
            }
          }
          
          document.querySelectorAll('.finks-2026-tab-pane.active').forEach(pane => {
            pane.classList.remove('active', 'show');
          });
          
          const thankYouTab = document.getElementById('finks-2026-thankyou-appointment');
          if (thankYouTab) {
            thankYouTab.classList.add('active', 'show');
          }
          
          if (typeof window.recalcOpenAccordion === 'function') {
            window.recalcOpenAccordion();
          }
          
          const section = document.getElementById('finks-2026-appointment-section');
          if (section) {
            section.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
          return true;
        }

        clearTimeout(timeoutId);

        let responseData = null;
        const contentType = res.headers.get('content-type');
        
        try {
          const text = await res.text();
          if (text && contentType && contentType.includes('application/json')) {
            try {
              responseData = JSON.parse(text);
            } catch (jsonError) {
            }
          }
        } catch (readError) {
          // Failed to read response, continue
        }

        if (res.ok || res.status >= 200 && res.status < 300) {
          this.updateThankYouPage();
          
          if (typeof _satellite !== 'undefined') {
            try {
              _satellite.track('bookAppointment');
            } catch (e) {
            }
          }
          
          document.querySelectorAll('.finks-2026-tab-pane.active').forEach(pane => {
            pane.classList.remove('active', 'show');
          });
          
          const thankYouTab = document.getElementById('finks-2026-thankyou-appointment');
          if (thankYouTab) {
            thankYouTab.classList.add('active', 'show');
          }
          
          if (typeof window.recalcOpenAccordion === 'function') {
            window.recalcOpenAccordion();
          }
          
          const section = document.getElementById('finks-2026-appointment-section');
          if (section) {
            section.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
          
          return true;
        } else {
          alert('Sorry, we couldn\'t book your appointment. Please try again or contact us directly.');
          return false;
        }

      } catch (err) {
        if (err.name === 'AbortError') {
          alert('Request timeout. Please check your connection and try again.');
        } else {
          alert('Network error – please try again or contact us directly.');
        }
        
        return false;
      }
    },

    updateAppointmentDetails() {
      const selectedPurpose = document.querySelector('input[name="apptPurpose"]:checked')?.value;
      const selectedLocation = document.querySelector('input[name="apptLocation"]:checked')?.value;
      const selectedLocationName = document.querySelector('input[name="apptLocation"]:checked')
        ?.closest('label')?.querySelector('.finks-2026-heading-30')?.textContent;

      if (selectedPurpose) {
        const purposeText = document.getElementById('finks-2026-apptPurposeText');
        if (purposeText) purposeText.textContent = selectedPurpose;
      }

      if (selectedLocationName) {
        const locationNameText = document.getElementById('finks-2026-apptLocationNameText');
        if (locationNameText) locationNameText.textContent = selectedLocationName;
      }

      if (selectedLocation) {
        const addressText = document.getElementById('finks-2026-apptAddressText');
        if (addressText) addressText.textContent = selectedLocation;
      }

      if (this.selectedDate && this.selectedTime) {
        const options = {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        };
        const formattedDate = this.selectedDate.toLocaleDateString('en-US', options);
        
        const [hours, minutes] = this.selectedTime.split(':');
        const hour = parseInt(hours);
        const period = hour >= 12 ? 'p.m.' : 'a.m.';
        const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
        const displayMinutes = minutes === '00' ? '' : `:${minutes}`;
        
        const dateTimeText = `${formattedDate} at ${displayHour}${displayMinutes} ${period}`;
        
        const dateTimeTextEl = document.getElementById('finks-2026-apptDateTimeText');
        if (dateTimeTextEl) dateTimeTextEl.textContent = dateTimeText;
        
        const dateTextEl = document.getElementById('finks-2026-apptDateText');
        if (dateTextEl) dateTextEl.textContent = dateTimeText;
      } else {
        const dateTimeTextEl = document.getElementById('finks-2026-apptDateTimeText');
        if (dateTimeTextEl) dateTimeTextEl.textContent = 'To be confirmed by our team';
        
        const dateTextEl = document.getElementById('finks-2026-apptDateText');
        if (dateTextEl) dateTextEl.textContent = 'To be confirmed by our team';
      }

      const locationValue = this.getLocationValue();

      const appointmentDetails = {
        purpose: selectedPurpose,
        location: locationValue || selectedLocation,
        locationName: selectedLocationName,
        date: this.selectedDate ? this.selectedDate.toISOString().split('T')[0] : null,
        time: this.selectedTime,
        dateTime: document.getElementById('finks-2026-selectedDateTime')?.value ||
          (this.selectedDate && this.selectedTime
            ? `${this.selectedDate.toISOString().split('T')[0]} ${this.selectedTime}`
            : null),
      };
      
      const appointmentInfoInput = document.getElementById('finks-2026-appointmentInformation');
      if (appointmentInfoInput) {
        appointmentInfoInput.value = JSON.stringify(appointmentDetails);
      }
      
      this.updateAppointmentTrackingInfo();
    },

    updateAppointmentTrackingInfo() {
      const selectedPurpose = document.querySelector('input[name="apptPurpose"]:checked')?.value;
      let appointmentObject = '';
      
      if (selectedPurpose === 'Discover the Rolex collections') {
        appointmentObject = 'collection discovery';
      } else if (selectedPurpose === 'Bring or collect your watch for servicing') {
        appointmentObject = 'watch servicing';
      } else {
        appointmentObject = selectedPurpose || '';
      }
      
      if (this.selectedDate && this.selectedTime && appointmentObject) {
        const dayOfWeek = this.selectedDate.toLocaleDateString('en-US', { weekday: 'long' });
        const dateString = this.selectedDate.toISOString().split('T')[0];
        
        const timeString = this.selectedTime;
        
        window.appointmentInformation = `${appointmentObject}|${dayOfWeek}|${dateString}|${timeString}`;
      }
    },

    updateThankYouPage() {
      const title = document.getElementById('finks-2026-fldSex')?.value;
      const firstName = document.getElementById('finks-2026-fldFirstName')?.value;
      const lastName = document.getElementById('finks-2026-fldLastName')?.value;
      
      const selectedLocationName = document.querySelector('input[name="apptLocation"]:checked')
        ?.closest('label')?.querySelector('.finks-2026-heading-30')?.textContent;
      const selectedLocation = document.querySelector('input[name="apptLocation"]:checked')?.value;
      
      const locationNameText = document.getElementById('finks-2026-apptLocationNameText');
      if (locationNameText) locationNameText.textContent = selectedLocationName || '';
      
      const addressText = document.getElementById('finks-2026-apptAddressText');
      if (addressText) addressText.textContent = selectedLocation || '';
      
      const selectedPurpose = document.querySelector('input[name="apptPurpose"]:checked')?.value;
      let purposeText = '';
      
      if (selectedPurpose === 'Discover the Rolex collections') {
        purposeText = 'Discover the Rolex collections';
      } else if (selectedPurpose === 'Bring or collect your watch for servicing') {
        purposeText = 'Bring or collect your watch for servicing';
      } else {
        purposeText = selectedPurpose || '';
      }
      
      const thankYouPurpose = document.getElementById('finks-2026-thankYouPurpose');
      if (thankYouPurpose) thankYouPurpose.textContent = purposeText;
      
      if (this.selectedDate && this.selectedTime) {
        const options = {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric'
        };
        const formattedDate = this.selectedDate.toLocaleDateString('en-US', options);
        
        const timeSlotText = `${formattedDate} at ${this.selectedHourSlot}`;
        
        const thankYouTimeslot = document.getElementById('finks-2026-thankYouChoosenTimeslot');
        if (thankYouTimeslot) thankYouTimeslot.textContent = timeSlotText;
      } else {
        const thankYouTimeslot = document.getElementById('finks-2026-thankYouChoosenTimeslot');
        if (thankYouTimeslot) thankYouTimeslot.textContent = 'To be confirmed by our team';
      }

      // Setup modify button
      const modifyBtn = document.getElementById('finks-2026-modifyBtn');
      const emailInput = document.getElementById('finks-2026-fldEmail');
      if (modifyBtn && emailInput) {
        modifyBtn.onclick = () => {
          if (!this.config.modifyPageUrl) {
            console.error('Modify page URL not configured');
            return;
          }
          
          let modifyUrl = `${this.config.modifyPageUrl}?email=${encodeURIComponent(emailInput.value)}`;
          
          // Include location if available
          const location = this.getLocationValue();
          if (location) {
            modifyUrl += `&location=${encodeURIComponent(location)}`;
          }
          
          window.location.href = modifyUrl;
        };
      }
    },

    updateStoreAddressSelect() {
      const selectedLocationRadio = document.querySelector('input[name="apptLocation"]:checked');
      if (!selectedLocationRadio) {
        return;
      }
      
      // Get the store name from the location card
      const storeName = selectedLocationRadio
        .closest('label')
        ?.querySelector('.finks-2026-heading-30')
        ?.textContent
        ?.trim();
      
      if (!storeName) {
        return;
      }
      
      // Find and select the matching option in the store address select
      const storeAddressSelect = document.getElementById('finks-2026-fldStoreAddress');
      if (!storeAddressSelect) {
        return;
      }
      
      // Try to find option by value (store_name) or text content
      const options = Array.from(storeAddressSelect.options);
      for (const option of options) {
        if (option.value === storeName || option.textContent.trim() === storeName) {
          storeAddressSelect.value = option.value;
          // Trigger change event to update any dependent UI
          storeAddressSelect.dispatchEvent(new Event('change', { bubbles: true }));
          break;
        }
      }
    },

    updateSelectedLocation() {
      const selectedLocationName = document.querySelector('input[name="apptLocation"]:checked')
        ?.closest('label')?.querySelector('.finks-2026-heading-30')?.textContent;
      const selectedLocation = document.querySelector('input[name="apptLocation"]:checked')?.value;
      
      if (selectedLocationName) {
        const locationNameText = document.getElementById('finks-2026-apptLocationNameText');
        if (locationNameText) locationNameText.textContent = selectedLocationName;
      }
      
      if (selectedLocation) {
        const addressText = document.getElementById('finks-2026-apptAddressText');
        if (addressText) addressText.textContent = selectedLocation;
      }
    }
  };

  // Make it globally accessible
  window.FinksAppointment = FinksAppointment;
})();
